import { render } from "./UnCryptosSearchResults.vue?vue&type=template&id=167f6fb0"
import script from "./UnCryptosSearchResults.vue?vue&type=script&lang=js"
export * from "./UnCryptosSearchResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__